import { useNavigate } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import ravenLogo from "@/assets/raven-logo.png";

export function LandingFooter() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-muted/50 border-t border-border py-12 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img src={ravenLogo} alt="Raven Logo" className="h-8 w-8" />
              <span className="text-xl font-bold text-primary">Raven</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Sistema de gestión profesional para empresas de instalaciones de seguridad
            </p>
          </div>

          {/* Enlaces */}
          <div>
            <h4 className="font-semibold mb-4">Enlaces</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-muted-foreground hover:text-primary transition-colors">
                  Características
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('benefits')} className="text-muted-foreground hover:text-primary transition-colors">
                  Beneficios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-muted-foreground hover:text-primary transition-colors">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/login')} className="text-muted-foreground hover:text-primary transition-colors">
                  Iniciar Sesión
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Términos y Condiciones
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-muted-foreground">
                <Mail className="h-4 w-4" />
                <a href="mailto:info@raven.app" className="hover:text-primary transition-colors">
                  info@raven.app
                </a>
              </li>
              <li className="flex items-center gap-2 text-muted-foreground">
                <Phone className="h-4 w-4" />
                <a href="tel:+34900000000" className="hover:text-primary transition-colors">
                  +34 900 000 000
                </a>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>España</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>© {currentYear} Raven Systems. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
